import { ftAccessToken, ftRefreshToken } from "../constants/Constants";
import { refreshToken } from "./AuthService";
import { properties } from "../properties";

export function fetchPublicSubmission(userId, manuscriptId, firstCall = true) {
    return new Promise((resolve, reject) => {
        const accessToken = localStorage.getItem(ftAccessToken)?.replaceAll('"', '');
        const xhttp = new XMLHttpRequest();
        xhttp.open("GET", `${properties.host}/profile/${userId}/submission/${manuscriptId}`, true);
        xhttp.setRequestHeader("Authorization", "Bearer " + accessToken);
        xhttp.onreadystatechange = function () {
            if (this.readyState === 4) {
                if (this.status === 200) {
                    resolve(JSON.parse(this.responseText));
                } else if ((this.status === 401 || this.status === 403) && firstCall) {
                    refreshToken().then(newAccessToken => {
                        localStorage.setItem(ftAccessToken, JSON.stringify(newAccessToken));
                        fetchPublicSubmission(userId, manuscriptId, false).then(resolve).catch(reject);
                    }).catch(() => {
                        localStorage.removeItem(ftAccessToken);
                        localStorage.removeItem(ftRefreshToken);
                        reject({ error: new Error("Failed to refresh token."), status: this.status });
                    });
                } else {
                    reject(new Error("Failed to fetch submission."));
                }
            }
        };
        xhttp.send();
    });
}

export function fetchProfile(userId, firstCall = true) {
    return new Promise((resolve, reject) => {
        const accessToken = localStorage.getItem(ftAccessToken)?.replaceAll('"', '');
        const xhttp = new XMLHttpRequest();
        xhttp.open("GET", `${properties.host}/profile/${userId}`, true);
        xhttp.setRequestHeader("Authorization", "Bearer " + accessToken);
        xhttp.onreadystatechange = function () {
            if (this.readyState === 4) {
                if (this.status === 200) {
                    resolve(JSON.parse(this.responseText));
                } else if ((this.status === 401 || this.status === 403) && firstCall) {
                    refreshToken().then(newAccessToken => {
                        localStorage.setItem(ftAccessToken, JSON.stringify(newAccessToken));
                        fetchProfile(userId, false).then(resolve).catch(reject);
                    }).catch(() => {
                        localStorage.removeItem(ftAccessToken);
                        localStorage.removeItem(ftRefreshToken);
                        reject({ error: new Error("Failed to refresh token."), status: this.status });
                    });
                } else if (this.status === 404) {
                    resolve({ isPublic: false, notFound: true });
                } else {
                    reject(new Error("Failed to fetch profile."));
                }
            }
        };
        xhttp.send();
    });
}
